import { ACL_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type { ReactElement } from 'react'
import type { SpacePutBody } from '@eggplant/types'

interface Props {
  spaceId: string
  children?: (response: SpacePutBody[]) => ReactElement
  onSuccess?: (response: SpacePutBody[]) => void
  onError?: () => void
}

const GetSpaceMembersRequest = ({
  spaceId,
  children,
  onSuccess,
  onError
}: Props) => {
  const queryParams = '?principal_types=user&principal_types=group' // backend require this format but object cannot have duplicate keys name
  const url = `${ACL_SERVICE}/acls/space/${spaceId}${queryParams}`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onError={onError}
      onSuccess={onSuccess}
      url={url}
    />
  )
}

export default GetSpaceMembersRequest
